// extracted by mini-css-extract-plugin
export default {"UpsellBannerOcticon":"UpsellBanner-module__UpsellBannerOcticon--orEav","UpsellBannerHeading":"UpsellBanner-module__UpsellBannerHeading--zyM_e"};